import { render } from "./OrdersManager.vue?vue&type=template&id=12b0eeda&scoped=true"
import script from "./OrdersManager.vue?vue&type=script&lang=js"
export * from "./OrdersManager.vue?vue&type=script&lang=js"

import "./OrdersManager.vue?vue&type=style&index=0&id=12b0eeda&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b0eeda"]])

export default __exports__